import React, { Component } from 'react';

import { Form,Button } from 'react-bootstrap';
import './addCustom.css';

import { connect } from 'react-redux';
import actions from "./../../../store/Actions/index.js";
import { withRouter } from 'react-router';
import Loader from 'react-loader-spinner'

class AddCustom extends Component{
    state={
        fileName:"",
        image:"",
        apiWait:false,
        date:"",
        description:"",
        tag:""

    }
    onSubmit = async(evt) => {
        evt.preventDefault(); 
        this.setState({apiWait:true})
        console.log("this tate description",this.state.description);
        console.log("this state tag",this.state.tag);
        await this.props.uploadCustom({file:this.state.image, description:this.state.description});
        this.setState({apiWait:false});
        this.props.onSave();
    }
    render(){
        return(
            <div>
                <Form onSubmit={this.onSubmit}>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <Form.Group>
                                    <Form.Label>
                                        Report Name
                                    </Form.Label>
                                    <Form.Control required as="input" placeholder="Report Name" onChange={(evt) =>{ 
                                        this.setState({description:evt.target.value});
                                    }}>
                                    </Form.Control>
                                </Form.Group>
                            </div>
                           
                            <div className="col-md-12">
                                <Form.Group>
                                    <Form.Label>
                                        Uplaod File (.pdf only)
                                    </Form.Label>
                                    <Form.Control required type="file" placeholder="File" accept=".pdf" onChange={(evt) =>{ 
                                        this.setState({image:evt.target.files[0]});
                                    }}>
                                    </Form.Control>
                                </Form.Group>
                            </div>

                            {!this.state.apiWait && <div required className="col-md-12 text-right submitbtn">
                                <Button varient="primary" type="submit">
                                    Submit
                                </Button>
                            </div>
                            }
                            {this.state.apiWait && <div className="col-md-12 text-right">
                                {/* <img src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif"></img> */}
                                <Loader
                                   type="Oval"
                                   color="#00BFFF"
                                   height={100}
                                   width={100}
                            //    timeout={3000} //3 secs
                            />
                            </div>
                            } 
                        </div>
                    </div>   
                </Form>
            </div>    
        )
    }
}

const mapStateToProps = state => ({
    list:state.list
});

const mapDispatchToProps = dispatch => ({
    // addNewReport: (v) => dispatch(actions.addNewReport(v)),
    uploadCustom:(v) => dispatch(actions.uploadCustom(v))
})

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AddCustom));